import React from "react";
import PropTypes from "prop-types";
import { intlShape, injectIntl } from "react-intl";
import intlMessages from "components/messagesDescription";
import CarouselNav from "components/dashboard/CarouselNav";
import TrackSsoUrlComponent from "components/common/TrackSsoUrlComponent";

const renderItem = (item, formatMessage) => (
  <div key={item.title}>
    <h3>{formatMessage({ id: item.title, defaultMessage: item.title })}</h3>
    <div
      dangerouslySetInnerHTML={{
        __html: formatMessage({
          id: item.descriptionHtml,
          defaultMessage: item.descriptionHtml,
        }),
      }}
    />
  </div>
);

class MessageBoard extends React.Component {
  state = {
    currIdx: 0,
  };

  onSelect = idx => {
    const max = this.props.messages ? this.props.messages.length : 0;
    const currIdx = (idx % max + max) % max;

    this.setState({
      currIdx,
    });
  };

  render() {
    const { messages, getShortLivedToken } = this.props;
    const { currIdx } = this.state;
    const { formatMessage } = this.props.intl;
    return (
      messages && (
        <article className="card">
          <header>
            <h2>{formatMessage(intlMessages.messageBoardDescription)}</h2>
          </header>
          <section>
            {messages &&
              messages.map(
                (item, idx) => (currIdx == idx ? renderItem(item, formatMessage) : null)
              )}
            <TrackSsoUrlComponent getShortLivedToken={getShortLivedToken} />
          </section>
          <footer>
            <CarouselNav
              noOfItems={messages ? messages.length : 0}
              onSelect={this.onSelect}
              currIdx={currIdx}
              separator={formatMessage(intlMessages.ofSeparator)}
            />
          </footer>
        </article>
      )
    );
  }
}

MessageBoard.propTypes = {
  messages: PropTypes.array.isRequired,
  intl: intlShape.isRequired,
  getShortLivedToken: PropTypes.func.isRequired,
};

export default injectIntl(MessageBoard);



// WEBPACK FOOTER //
// ./components/dashboard/widgets/MessageBoard.js